import { ConfirmDialog } from "@/components/ui/confirm-dialog";

interface DeleteFolderDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  folderName: string;
  projectCount: number;
  childFolderCount: number;
  onConfirm: () => void;
}

export function DeleteFolderDialog({
  open,
  onOpenChange,
  folderName,
  projectCount,
  childFolderCount,
  onConfirm,
}: DeleteFolderDialogProps) {
  const hasCascadeEffects = projectCount > 0 || childFolderCount > 0;

  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Delete Folder?"
      description={
        <>
          Are you sure you want to delete <strong>{folderName}</strong>?
          {hasCascadeEffects ? (
            <ul className="mt-2 list-disc space-y-1 pl-5">
              {projectCount > 0 ? (
                <li>
                  {projectCount} project{projectCount !== 1 ? "s" : ""} will be moved to My
                  Projects.
                </li>
              ) : null}
              {childFolderCount > 0 ? (
                <li>
                  {childFolderCount} subfolder{childFolderCount !== 1 ? "s" : ""} will become
                  top-level folder{childFolderCount !== 1 ? "s" : ""}.
                </li>
              ) : null}
            </ul>
          ) : null}
        </>
      }
      confirmLabel="Delete"
      destructive
      onConfirm={onConfirm}
    />
  );
}
